const en = {
  createTitle: "Create",
  customizeTitle: "Customize",
  publishTitle: "Publish",
  createIcon: "/images/steps/createIcon.svg",
  customizeIcon: "/images/steps/customizeIcon.svg",
  publishIcon: "/images/steps/publishIcon.svg",
  faqIcon: "/images/faq/faqIcon.svg",
  productsSection: {
    title: "Our Products",
    description:
      "No technical expertise required our step-by-step guide ensures anyone can generate and use QR codes effectively.",
  },
  advancedSettings: {
    item_0: {
      id: "0",
      title: "Custom Link",
      description: "Modify the default /ID link to your preferred /yourlink.",
      icon: "/images/advancedSettings/customLink.svg",
    },
    item_1: {
      id: "1",
      title: "Password Protection",
      description:
        "Safeguard your page by implementing a password requirement.",
      icon: "/images/advancedSettings/passwordProtection.svg",
    },
    item_2: {
      id: "2",
      title: "Scheduled Display",
      description:
        "Define specific date ranges during which your content will be accessible.",
      icon: "/images/advancedSettings/scheduledDisplay.svg",
    },
    item_3: {
      id: "3",
      title: "Scan Limit Configuration",
      description:
        "<ul><li>Define the maximum number of unique scans allowed â“˜. </li><li>Set a custom redirect page to be displayed when the scan limit is exceeded.</li></ul>",
      icon: "/images/advancedSettings/scanLimitConfiguration.svg",
    },
  },
  analyticsSection: {
    title: "Analytics",
    description:
      "Embedded intelligence automatically highlights your most valuable marketing insights, enabling swift action to achieve your goals",
  },
  fileMangerSection: {
    title: "File Manger",
    description:
      "Embedded intelligence automatically highlights your most valuable marketing insights, enabling swift action to achieve your goals",
  },
  allPlansFeatureCard: {
    item_0: {
      id: "0",
      title: "Unlimited Dynamic QR",
      description: "Create and update unlimited QRs in real time",
    },
    item_1: {
      id: "1",
      title: "Variety of QR Types",
      description:
        "Select from multiple QR types, including URL, PDF, Menu, and more.",
    },
    item_2: {
      id: "2",
      title: "Unlimited Members",
      description:
        "Collaborate with other users in creating and managing your QR Codes.",
    },
    item_3: {
      id: "3",
      title: "Complete QR Analytics",
      description: "Access statistics on scans, locations, and user devices.",
    },
    item_4: {
      id: "4",
      title: "QR Editing and Management",
      description: "Customize your QRs with colors, fonts, logos, and more.",
    },
    item_5: {
      id: "5",
      title: "Unlimited Scans",
      description: "Your QRs can be scanned without any limits.",
    },
    item_6: {
      id: "6",
      title: "Bulk Creation and Download",
      description:
        "Generate multiple QRs using CSV and download them all at once.",
    },
    item_7: {
      id: "7",
      title: "Premium Support",
      description:
        "Receive personalized technical assistance to resolve any issues promptly.",
    },
    item_8: {
      id: "8",
      title: "Flexible Cancellation Policy",
      description: "Cancel your subscription anytime without restrictions.",
    },
    buttonTitle: "Create Now",
    buttonUrl: "#",
  },
  vCardPage: {
    heroSection: {
      title: "QR VCARD",
      description: "Share your app links on all platform in one place",
      buttonTitle: "Create New",
      buttonUrl: "/",
    },
    stepsSection: {
      stepsTitle: "Instantly Engage and Connect Instantly",
      stepsDescription:
        "With ease and convenience in mind, we present a cutting-edge solution that allows you to share your vCard with exceptional practicality. Say goodbye to the complexities of traditional methods and hello to a seamless process that prioritizes speed and simplicity.",
      createSubTitle: "Grab attention with just a quick glance",
      createImage: "/images/vCard/createImage.svg",
      createDescription:
        "<ul><li>Add your avatar.</li><li>Add your full name, job title, and bio.</li><li>Provide multiple contact options, such as phone number, email address, website URL, and location.</li><li>Link to your social media accounts to connect with others and share your content.</li></ul>",
      customizeSubTitle:
        "Customize your page with personal touches that make it stand out.",
      customizeImage: "/images/vCard/customizeImage.svg",
      customizeDescription:
        "<ul><li>Customize the appearance of the elements with ease.</li><li>Select your preferred background, button, and text colors.</li><li>Choose from a diverse collection of over 100 fonts.</li><li>Save your personalized style as a theme for quick and convenient use in the future.</li></ul>",
      publishSubTitle: "Capture attention with just a brief look.",
      publishImage: "/images/vCard/publishImage.svg",
      publishDescription:
        "<ul><li>Save and share your vCard </li><li>Integrate your QR Code on various mediums, such as flyers, billboards, digital posters, and more, to create a seamless and natural engagement between customers and your brand.</li></ul>",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    appFeatures: {
      item_0: {
        id: "0",
        title: "Easy To Update",
        subTitle: "No need to stress over mistakes",
        description:
          "If you discover an error or wish to update your contact details, rest assured; all information can be easily modified at any time without the need for a new QR code.",
      },
      item_1: {
        id: "1",
        title: "QR Code Style",
        subTitle: "",
        description:
          "Personalize your QR Code with your logo, brand colors, distinctive patterns, frames, and more to capture attention and make it visually appealing.",
      },
      item_2: {
        id: "2",
        title: "Theme",
        subTitle: "Create and Apply Themes to QR Codes and vCards",
        description:
          "Customize and save your preferred page style and QR Code style as a theme. This theme can then be conveniently applied to any existing or newly created vCard.",
      },
      item_3: {
        id: "3",
        title: "Bulk Import",
        subTitle: "",
        description:
          "Importing an Excel file to get a bunch of vCards is a piece of cake. With just one click, you'll have all the vCards and their QR codes ready to go in no time. It's like magic!",
      },
      item_4: {
        id: "4",
        title: "Analytics",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "<ul><li>Monitor the frequency of scans and link visits associated with your QR code.</li><li>Identify the geographical locations from which your QR code is being accessed.</li><li>Analyze the types and language of user's devices used to scan your QR code.</li><li>Track the engagement of each link within the page.</li></ul>",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_5: {
        id: "5",
        title: "Custom Domain",
        subTitle: " ",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
      item_6: {
        id: "6",
        title: "Dynamic Organization Details",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
    },
    bannerWithTitle: {
      title: "Start Creating Your vCard QR Code Today!",
      description:
        "Sign up now and make sharing your contact details easier than ever",
      background: "/images/bannerWithContent/bgpurple.svg",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    FAQ: {
      item_0: {
        id: "0",
        title: "How do I create a QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_1: {
        id: "1",
        title: "What is a dynamic QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_2: {
        id: "2",
        title: "Usage",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
    },
  },
  landingPage: {
    heroSection: {
      title: "QR LANDING PAGE",
      description: "Share your app links on all platform in one place",
      buttonTitle: "Create New",
      buttonUrl: "/",
    },
    stepsSection: {
      stepsTitle: "Seamlessly Attract Your Audience",
      stepsDescription:
        "With QR Hub's landing page solutions, you can create stunning and effective landing pages that captivate your audience and drive conversions. Say goodbye to complicated setups and hello to a seamless, user-friendly experience.",
      createSubTitle: "Attract Customers with a Single Scan",
      createImage: "/images/vCard/createImage.svg",
      createDescription:
        "<ul><li>Create a QR code for your landing page to connect with customers instantly.</li> <li>Present the best of your business with a simple scan.</li> <li>Promote your products or services effectively.</li> <li>Make it easy for customers to access relevant information and connect with you.</li></ul>",
      customizeSubTitle: "Design Your Landing Page Your Way",
      customizeImage: "/images/vCard/customizeImage.svg",
      customizeDescription:
        "<ul> <li>Customize your page with text, images and advertising videos, </li> <li>Include links to your website for more information.</li> <li>Make your landing page visually appealing and informative.</li> </ul>",
      publishSubTitle: "Ensure Easy Access for Everyone",
      publishImage: "/images/vCard/publishImage.svg",
      publishDescription:
        "<ul> <li>Generate a QR code that adapts perfectly to any device.</li> <li>Create a QR code for integration into printed magazines, newspaper ads, and direct mail campaigns</li> <li>Integrate the QR code on digital platforms and social media.</li> <li>Update your landing page anytime without needing a new QR code.</li> </ul>",
      buttonTitle: "Create Your Landing Page QR Now",
      buttonUrl: "#",
    },
    appFeatures: {
      item_0: {
        id: "0",
        title: "Easy To Update",
        subTitle: "No need to stress over mistakes",
        description:
          "<b>No need to stress over mistakes<b><br>If you discover an error or wish to update the landing page content, rest assured; all        information can be easily modified at any time without the need to generate a new QR code.",
      },
      item_1: {
        id: "1",
        title: "QR Code Style",
        subTitle: "Create a QR code design in your own unique style",
        description:
          "Add your logo, Icon, brand colors, distinctive patterns, frames, and more to make it visually appealing and capture attention.",
      },
      item_2: {
        id: "2",
        title: "Theme",
        subTitle: "Custom Theme Management for Pages and QR Codes",
        description:
          "You can save both the page style and QR code style in your custom theme and reuse them on any page you create. Additionally, you have the option to apply any theme modifications across all pages that use the same theme.",
      },
      item_3: {
        id: "3",
        title: "Dynamic Organization Details",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media links and locations in the account management section, you can display them in the page in one click",
      },
      item_4: {
        id: "4",
        title: "Analytics",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "<ul> <li>Monitor the frequency of scans and link visits associated with your QR code.</li> <li>Identify the geographical locations from which your QR code is being accessed.</li> <li>Analyze the types and language of user's devices used to scan your QR code.</li> <li>Track the engagement of each link within the page.</li> </ul>",
      },
      item_5: {
        id: "5",
        title: "Custom Domain",
        subTitle: "White Labeling URLs in QRHUB App",
        description:
          "QRHUB App's Custom Domain feature allows you to seamlessly integrate your brand into every QR code generated by the platform. By using a custom domain, you can white label URLs, ensuring that all links associated with QR codes reflect your brand identity rather than the default QRHUB domain.",
      },
      item_6: {
        id: "6",
        title: "Dynamic Organization Details ",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
    },
    bannerWithTitle: {
      title: "Start Creating Your vCard QR Code Today!",
      description:
        "Sign up now and make sharing your contact details easier than ever",
      background: "/images/bannerWithContent/bgpurple.svg",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    FAQ: {
      item_0: {
        id: "0",
        title: "How do I create a QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_1: {
        id: "1",
        title: "What is a dynamic QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_2: {
        id: "2",
        title: "Usage",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
    },
  },
  qrAppLinks: {
    heroSection: {
      title: "QR APP LINKS",
      description: "Share your app links on all platform in one place",
      buttonTitle: "Create New",
      buttonUrl: "/",
    },
    stepsSection: {
      stepsTitle: "Boost Your App Downloads",
      stepsDescription:
        "QR Hub's app solutions enable you to create and share app download links seamlessly. Improve user experience by providing quick and easy access to your app via QR codes.",
      createSubTitle: "Easily Share Your App",
      createImage: "/images/vCard/createImage.svg",
      createDescription:
        "<ul><li>Offer a unique QR code for all app stores.</li><li>Enable customers to choose their preferred download platform.</li><li>Ensure secure sharing of your app.</li><li>Provide a quick and accessible way to distribute your app.</li></ul>",
      customizeSubTitle: "Design Your App Page Your Way",
      customizeImage: "/images/vCard/customizeImage.svg",
      customizeDescription:
        "<ul><li>Add app descriptions and download links.</li><li>Select appealing design and colors.</li><li>Make the page attractive and user-friendly.</li><li>Personalize to match your brand.</li></ul>",
      publishSubTitle: "Reach Your Audience Everywhere",
      publishImage: "/images/vCard/publishImage.svg",
      publishDescription:
        "<ul><li>Smoothly publish and share your app page.</li><li>Design a QR code for quick sharing on social media posts, blog articles, and newsletters.</li><li>Ensure compatibility with all devices.</li><li>Expand your reach with seamless distribution.</li></ul>",
      buttonTitle: "Create Your App QR Now",
      buttonUrl: "#",
    },
    appFeatures: {
      item_0: {
        id: "0",
        title: "Easy To Update",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_1: {
        id: "1",
        title: "QR Code Style",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_2: {
        id: "2",
        title: "Theme",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_3: {
        id: "3",
        title: "Bulk Import",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_4: {
        id: "4",
        title: "Analytics",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_5: {
        id: "5",
        title: "Custom Domain",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_6: {
        id: "6",
        title: "Dynamic Organization Details ",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
    },
    bannerWithTitle: {
      title: "Start Creating Your vCard QR Code Today!",
      description:
        "Sign up now and make sharing your contact details easier than ever",
      background: "/images/bannerWithContent/bgpurple.svg",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    FAQ: {
      item_0: {
        id: "0",
        title: "How do I create a QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_1: {
        id: "1",
        title: "What is a dynamic QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_2: {
        id: "2",
        title: "Usage",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
    },
  },
  qrBusiness: {
    heroSection: {
      title: "QR BUSINESS",
      description: "Share your app links on all platform in one place",
      buttonTitle: "Create New",
      buttonUrl: "/",
    },
    stepsSection: {
      stepsTitle: "Instantly Engage and Connect",
      stepsDescription:
        "With ease and convenience in mind, we present a cutting-edge solution that allows you to share your vCard with exceptional practicality. Say goodbye to the complexities of traditional methods and hello to a seamless process that prioritizes speed and simplicity.",
      createSubTitle: "Grab attention with just a quick glance",
      createImage: "/images/vCard/createImage.svg",
      createDescription:
        "<ul><li>Add your avatar. </li><li>Add your full name, job title, and bio.</li><li>rovide multiple contact options, such as phone number, email address, website URL, and location.</li><li>Link to your social media accounts to connect with others and share your content.</li></ul>",
      customizeSubTitle:
        "Customize your page with personal touches that make it stand out.",
      customizeImage: "/images/vCard/customizeImage.svg",
      customizeDescription:
        "<ul><li>Customize the appearance of the elements with ease.</li><li>elect your preferred background, button, and text colors.</li><li>Choose from a diverse collection of over 100 fonts.</li><li>Save your personalized style as a theme for quick and convenient use in the future.</li></ul>",
      publishSubTitle: "Grab attention with just a quick glance",
      publishImage: "/images/vCard/publishImage.svg",
      publishDescription:
        "<ul><li>Save and share your vCard.</li><li>Integrate your QR Code on various mediums, such as flyers, billboards, digital posters, and more, to create a seamless and natural engagement between customers and your brand.</li></ul>",
      buttonTitle: "Create Your Business QR Now",
      buttonUrl: "#",
    },
    appFeatures: {
      item_0: {
        id: "0",
        title: "Easy To Update",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_1: {
        id: "1",
        title: "QR Code Style",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_2: {
        id: "2",
        title: "Theme",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_3: {
        id: "3",
        title: "Bulk Import",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_4: {
        id: "4",
        title: "Analytics",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_5: {
        id: "5",
        title: "Custom Domain",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_6: {
        id: "6",
        title: "Dynamic Organization Details ",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
    },
    bannerWithTitle: {
      title: "Start Creating Your vCard QR Code Today!",
      description:
        "Sign up now and make sharing your contact details easier than ever",
      background: "/images/bannerWithContent/bgpurple.svg",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    FAQ: {
      item_0: {
        id: "0",
        title: "How do I create a QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_1: {
        id: "1",
        title: "What is a dynamic QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_2: {
        id: "2",
        title: "Usage",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
    },
  },
  qrDocuments: {
    heroSection: {
      title: "QR DOCUMENTS",
      description: "Share your app links on all platform in one place",
      buttonTitle: "Create New",
      buttonUrl: "/",
    },
    stepsSection: {
      stepsTitle: "Instantly Engage and Connect",
      stepsDescription:
        "With ease and convenience in mind, we present a cutting-edge solution that allows you to share your vCard with exceptional practicality. Say goodbye to the complexities of traditional methods and hello to a seamless process that prioritizes speed and simplicity.",
      createSubTitle: "Grab attention with just a quick glance",
      createImage: "/images/vCard/createImage.svg",
      createDescription:
        "<ul><li>Add your avatar. </li><li>Add your full name, job title, and bio.</li><li>rovide multiple contact options, such as phone number, email address, website URL, and location.</li><li>Link to your social media accounts to connect with others and share your content.</li></ul>",
      customizeSubTitle:
        "Customize your page with personal touches that make it stand out.",
      customizeImage: "/images/vCard/customizeImage.svg",
      customizeDescription:
        "<ul><li>Customize the appearance of the elements with ease.</li><li>elect your preferred background, button, and text colors.</li><li>Choose from a diverse collection of over 100 fonts.</li><li>Save your personalized style as a theme for quick and convenient use in the future.</li></ul>",
      publishSubTitle: "Grab attention with just a quick glance",
      publishImage: "/images/vCard/publishImage.svg",
      publishDescription:
        "<ul><li>Save and share your vCard.</li><li>Integrate your QR Code on various mediums, such as flyers, billboards, digital posters, and more, to create a seamless and natural engagement between customers and your brand.</li></ul>",
      buttonTitle: "Create Your Documents QR Now",
      buttonUrl: "#",
    },
    appFeatures: {
      item_0: {
        id: "0",
        title: "Easy To Update",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_1: {
        id: "1",
        title: "QR Code Style",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_2: {
        id: "2",
        title: "Theme",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_3: {
        id: "3",
        title: "Bulk Import",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_4: {
        id: "4",
        title: "Analytics",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_5: {
        id: "5",
        title: "Custom Domain",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_6: {
        id: "6",
        title: "Dynamic Organization Details ",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
    },
    bannerWithTitle: {
      title: "Start Creating Your vCard QR Code Today!",
      description:
        "Sign up now and make sharing your contact details easier than ever",
      background: "/images/bannerWithContent/bgpurple.svg",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    FAQ: {
      item_0: {
        id: "0",
        title: "How do I create a QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_1: {
        id: "1",
        title: "What is a dynamic QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_2: {
        id: "2",
        title: "Usage",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
    },
  },
  qrGallery: {
    heroSection: {
      title: "QR GALLERY",
      description: "Share your app links on all platform in one place",
      buttonTitle: "Create New",
      buttonUrl: "/",
    },
    stepsSection: {
      stepsTitle: "Transform Your Image Display",
      stepsDescription:
        "With QR Hub's gallery solutions, you can create visually appealing galleries that captivate your audience. Showcase multiple images with detailed context, including titles, descriptions, alt text, and links.",
      createSubTitle: "Share Your Image Gallery with Ease",
      createImage: "/images/vCard/createImage.svg",
      createDescription:
        "<ul><li>Select the images to share in your gallery.</li><li>Add all the images you want to promote events, products, artistic creations, and more.</li><li>Showcase the best of your company with a simple scan.</li><li>Engage your audience by highlighting key visuals.</li></ul>",
      customizeSubTitle: "Customize Your Image Gallery",
      customizeImage: "/images/vCard/customizeImage.svg",
      customizeDescription:
        "<ul><li>Give your gallery landing page an attractive look.</li><li>Customize the appearance with colors, frames, and descriptions.</li><li>Add your personal touch to make the gallery stand out.</li><li>Ensure your gallery reflects your brand's unique style.</li></ul>",
      publishSubTitle: "Reach a Wider Audience",
      publishImage: "/images/vCard/publishImage.svg",
      publishDescription:
        "<ul><li>Quickly publish and share your image gallery across various platforms.</li><li>Create a QR code for seamless integration into gallery brochures, artist portfolios, and show flyers.</li><li>Ensure compatibility with all devices, including tablets, PCs, and smartphones.</li><li>Adapt the gallery format to display images vertically or horizontally, with custom titles and descriptions.</li></ul>",
      buttonTitle: "Create Your Gallery Now",
      buttonUrl: "#",
    },
    appFeatures: {
      item_0: {
        id: "0",
        title: "Easy To Update",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_1: {
        id: "1",
        title: "QR Code Style",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_2: {
        id: "2",
        title: "Theme",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_3: {
        id: "3",
        title: "Bulk Import",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
        icon: "/images/advancedSettings/customLink.svg",
      },
      item_4: {
        id: "4",
        title: "Analytics",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_5: {
        id: "5",
        title: "Custom Domain",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_6: {
        id: "6",
        title: "Dynamic Organization Details ",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
    },
    bannerWithTitle: {
      title: "Start Creating Your vCard QR Code Today!",
      description:
        "Sign up now and make sharing your contact details easier than ever",
      background: "/images/bannerWithContent/bgpurple.svg",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    FAQ: {
      item_0: {
        id: "0",
        title: "How do I create a QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_1: {
        id: "1",
        title: "What is a dynamic QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_2: {
        id: "2",
        title: "Usage",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
    },
  },
  qrListOfLinks: {
    heroSection: {
      title: "QR LIST OF LINKS",
      description: "Share your app links on all platform in one place",
      buttonTitle: "Create New",
      buttonUrl: "/",
    },
    stepsSection: {
      stepsTitle: "Organize and Share Links with Ease",
      stepsDescription:
        "Create a comprehensive list of important links using QR Hub's list of links solution. Simplify the sharing process and ensure your audience can easily access all necessary resources through QR codes.",
      createSubTitle: "Effortlessly Share All Your Links",
      createImage: "/images/vCard/createImage.svg",
      createDescription:
        "<ul><li>Launch your campaign with a simple QR code that can be shared anywhere.</li><li>Link to all your social media channels, from LinkedIn to Snapchat, Pinterest to Tumblr.</li><li>Provide easy access to all your key links in one convenient place.</li><li>Engage your audience with a streamlined sharing experience.</li></ul>",
      customizeSubTitle: "Make Your Links Page Eye-Catching",
      customizeImage: "/images/vCard/customizeImage.svg",
      customizeDescription:
        "<ul><li>Design your landing page to attract your audience with custom images and colors.</li><li>Add a compelling description and title to highlight your content.</li><li>Match the page to your brand&rsquo;s look and feel.</li><li>Ensure the presentation is appealing and user-friendly.</li></ul>",
      publishSubTitle: "Maximize Your Reach",
      publishImage: "/images/vCard/publishImage.svg",
      publishDescription:
        "<ul><li>Directly publish your links page and share it on various platforms.</li><li>Produce a QR code for easy sharing on resource pages, blog posts, and educational materials.</li><li>Make sure your QR code works smoothly on all devices.</li><li>Update your links and information anytime without needing a new QR code.</li></ul>",
      buttonTitle: "Create Your List of Links Now",
      buttonUrl: "#",
    },
    appFeatures: {
      item_0: {
        id: "0",
        title: "Easy To Update",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_1: {
        id: "1",
        title: "QR Code Style",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_2: {
        id: "2",
        title: "Theme",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_3: {
        id: "3",
        title: "Bulk Import",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_4: {
        id: "4",
        title: "Analytics",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_5: {
        id: "5",
        title: "Custom Domain",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_6: {
        id: "6",
        title: "Dynamic Organization Details ",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
    },
    bannerWithTitle: {
      title: "Start Creating Your vCard QR Code Today!",
      description:
        "Sign up now and make sharing your contact details easier than ever",
      background: "/images/bannerWithContent/bgpurple.svg",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    FAQ: {
      item_0: {
        id: "0",
        title: "How do I create a QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_1: {
        id: "1",
        title: "What is a dynamic QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_2: {
        id: "2",
        title: "Usage",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
    },
  },
  qrVideos: {
    heroSection: {
      title: "QR Videos",
      description: "Showcase Your Videos Effortlessly",
      buttonTitle: "Create New",
      buttonUrl: "/",
    },
    stepsSection: {
      stepsTitle: "Elevate Your Video Sharing",
      stepsDescription:
        "QR Hub's video solutions allow you to create and share video content seamlessly. Provide an engaging and informative experience by distributing videos through QR codes.",
      createSubTitle: "Hassle-Free Video Sharing",
      createImage: "/images/vCard/createImage.svg",
      createDescription:
        "<ul><li>Instantly share your company's promotional videos, tutorials, event highlights, movies, and more with QR codes.</li><li>Make your content easily accessible to your audience.</li><li>Ensure a smooth and engaging promotional experience.</li></ul>",
      customizeSubTitle: "Tailor to Your Needs",
      customizeImage: "/images/vCard/customizeImage.svg",
      customizeDescription:
        "<ul><li>Customize your landing page with a unique title, description, colors, and a personalized button.</li><li>Provide a pleasant and simple customer experience.</li><li>Allow easy access to your content with optimal customization.</li></ul>",
      publishSubTitle: "Share with Ease",
      publishImage: "/images/vCard/publishImage.svg",
      publishDescription:
        "<ul><li>Smoothly publish and share your video page across various platforms.</li><li>Produce a QR code for easy inclusion on video thumbnails, email campaigns, and multimedia presentations.</li><li>Ensure seamless and natural engagement with your audience.</li></ul>",
      buttonTitle: "Create Your QR Videos Now",
      buttonUrl: "#",
    },
    appFeatures: {
      item_0: {
        id: "0",
        title: "Easy To Update",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_1: {
        id: "1",
        title: "QR Code Style",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_2: {
        id: "2",
        title: "Theme",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_3: {
        id: "3",
        title: "Bulk Import",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_4: {
        id: "4",
        title: "Analytics",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_5: {
        id: "5",
        title: "Custom Domain",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Safeguard your page by implementing a password requirement.",
      },
      item_6: {
        id: "6",
        title: "Dynamic Organization Details ",
        subTitle: "Add your company details in one click",
        description:
          "Once you added your organization, Logo, Name, contact information, social media  links and locations in the account management section, you can display them in the page in one click",
      },
    },
    bannerWithTitle: {
      title: "Start Creating Your vCard QR Code Today!",
      description:
        "Sign up now and make sharing your contact details easier than ever",
      background: "/images/bannerWithContent/bgpurple.svg",
      buttonTitle: "Create Your vCard Now",
      buttonUrl: "#",
    },
    FAQ: {
      item_0: {
        id: "0",
        title: "How do I create a QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_1: {
        id: "1",
        title: "What is a dynamic QR code?",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
      item_2: {
        id: "2",
        title: "Usage",
        subTitle: "Track scans, Locations, Devices, and Link engagement",
        description:
          "Sign up now and make sharing your contact details easier than ever",
      },
    },
  },
  headerItems: {
    items: {
      item_0: {
        title: "Products",
        url: "/en/products/",
        subItems: {
          item_0: {
            title: "Qr vCard",
            url: "/en/products/qr-vcard/",
          },
          item_1: {
            title: "Landing Page",
            url: "/en/products/qr-landing-page/",
          },
          item_2: {
            title: "QR Gallery",
            url: "/en/products/qr-image-gallery/",
          },
          item_3: {
            title: "QR Business",
            url: "/en/products/qr-business/",
          },
          item_4: {
            title: "QR List Of Links",
            url: "/en/products/qr-list-of-links/",
          },
          item_5: {
            title: "QR Documents",
            url: "/en/products/qr-documents/",
          },
          item_6: {
            title: "QR App Links",
            url: "/en/products/qr-app-links/",
          },
          item_7: {
            title: "QR Videos",
            url: "/en/products/qr-videos/",
          },
        },
      },
      item_1: {
        title: "Legal",
        url: "",
        subItems: {
          item_0: {
            title: "QRHUB Terms and Conditions",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
          item_1: {
            title: "QRHUB Notice for Copyright",
            url: "/en/legal/qrhub-notice-for-copyright",
          },
          item_2: {
            title: "QRHUB Disclaimers",
            url: "/en/legal/qrhub-disclaimers",
          },
          item_3: {
            title: "QRHUB Refund Policy",
            url: "/en/legal/qrhub-refund-policy",
          },
          item_4: {
            title: "QRHUB Privacy Policy",
            url: "/en/legal/qrhub-privacy-policy",
          },
          item_5: {
            title: "QRHUB Cookies Policy",
            url: "/en/legal/qrhub-cookies-policy",
          },
          item_6: {
            title: "QRHUB Comment Policy",
            url: "/en/legal/qrhub-comment-policy",
          },
          item_7: {
            title: "QRHUB Trademarks, Patents and Corporate Policies",
            url: "/en/legal/qrhub-trademarks-patents-corporate-policies",
          },
        },
      },
      item_2: {
        title: "Solutions",
        url: "/en/solutions/",
        subItems: {
          item_0: {
            title: "Education",
            url: "/en/solutions/education/",
          },
        },
      },
      item_3: {
        title: "Features",
        url: "/en/features/",
      },
      item_4: {
        title: "Pricing",
        url: "/en/pricing/",
      },
      item_5: {
        title: "Help Center",
        url: "/en/help-center/",
      },
    },
  },
  footerItems: {
    logo: "/images/footer/qrhublogo.svg",
    lists: {
      list_0: {
        id: "0",
        maintitle: "Products",
        items: {
          item_0: {
            title: "vCard Plus",
            url: "/en/products/qr-vcard-plus/",
          },
          item_1: {
            title: "Landing Page",
            url: "/en/products/qr-landing-page/",
          },
          item_2: {
            title: "List of Files",
            url: "/en/products/qr-list-of-files/",
          },
          item_3: {
            title: "Dynamic Link",
            url: "/en/products/qr-dynamic-link/",
          },
          item_4: {
            title: "List of Links",
            url: "/en/products/qr-list-of-links/",
          },
          item_5: {
            title: "Business Profile",
            url: "/en/products/qr-business-profile/",
          },
          item_6: {
            title: "Image Gallery",
            url: "/en/products/qr-image-gallery/",
          },
          item_7: {
            title: "App Links",
            url: "/en/products/qr-app-links/",
          },
          item_8: {
            title: "Video Playlist",
            url: "/en/products/qr-videos-playlist/",
          },
        },
      },
      list_1: {
        id: "1",
        maintitle: "Solutions",
        items: {
          item_0: {
            title: "Retail",
            url: "/en/solutions/retail",
          },
          item_1: {
            title: "Hospitality",
            url: "/en/solutions/hospitality",
          },
          item_2: {
            title: "Technology Software & Hardware",
            url: "/en/solutions/technology-software-hardware",
          },
          item_3: {
            title: "Insurance",
            url: "/en/solutions/insurance",
          },
          item_4: {
            title: "Professional Services",
            url: "/en/solutions/professional-services",
          },
          item_5: {
            title: "Consumer Packaged Goods",
            url: "/en/solutions/consumer-packaged-goods",
          },
          item_6: {
            title: "Media & Entertainment",
            url: "/en/solutions/media-entertainment",
          },
          item_7: {
            title: "Developers",
            url: "/en/solutions/developers",
          },
          item_8: {
            title: "Marketing Agency",
            url: "/en/solutions/marketing-agency",
          },
          item_9: {
            title: "Public figures",
            url: "/en/solutions/public-figures",
          },
          item_10: {
            title: "Restaurant",
            url: "/en/solutions/restaurant",
          },
          item_11: {
            title: "Education",
            url: "/en/solutions/education",
          },
          item_12: {
            title: "Financial Services",
            url: "/en/solutions/financial-services",
          },
          item_13: {
            title: "Healthcare",
            url: "/en/solutions/healthcare",
          },
        },
      },
      list_2: {
        id: "2",
        maintitle: "Legal",
        items: {
          item_0: {
            title: "Terms and Conditions",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
          item_1: {
            title: "Notice for Copyright",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
          item_2: {
            title: "Disclaimers",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
          item_3: {
            title: "Refund Policy",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
          item_4: {
            title: "Privacy Policy",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
          item_5: {
            title: "Cookies Policy",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
          item_6: {
            title: "Trademarks, Patents & Corporate Policies",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
          item_7: {
            title: "Comment Policy",
            url: "/en/legal/qrhub-terms-and-conditions",
          },
        },
      },
      list_3: {
        id: "3",
        maintitle: "Quick Links",
        items: {
          item_0: {
            title: "Register",
            url: "dashboard_url",
          },
          item_1: {
            title: "Pricing",
            url: "/en/pricing/",
          },
          item_2: {
            title: "Support",
            url: "/en/help-center",
          },
          item_3: {
            title: "Need Help?",
            url: "https://qhb.io/help",
          },
        },
      },
    },
    copyright: "- Static & Dynamic QR Code Solutions",
    socialIcons: {
      item_0: {
        title: "Facebook",
        icon: "/images/footer/facebook.svg",
        url: "https://www.facebook.com/qrhub.io",
      },
      item_1: {
        title: "Instagram",
        icon: "/images/footer/instagram.svg",
        url: "https://www.instagram.com/qrhub.io/",
      },
      item_2: {
        title: "Threads",
        icon: "/images/footer/threads.svg",
        url: "https://www.threads.com/@qrhub.io",
      },
      item_3: {
        title: "Linkedin",
        icon: "/images/footer/linkedin.svg",
        url: "https://www.linkedin.com/company/qrhub-global/",
      },
      item_4: {
        title: "X",
        icon: "/images/footer/x.svg",
        url: "https://x.com/qrhubglobal",
      },
      item_5: {
        title: "Pinterest",
        icon: "/images/footer/pinterest.svg",
        url: "https://www.pinterest.com/qrhubglobal/",
      },
    },
  },
  legalPages: {
    qrhubTermsAndConditions: {
      id: "0",
      title: "QRHUB Terms and Conditions",
      effectiveDate: "November 15, 2023",
      lastModifiedDate: "November 7, 2023",
      description:
        "<p>Welcome to QRHUB! These Terms and Conditions govern your use of our website and services. By accessing or using QRHUB, you agree to be bound by these terms. If you do not agree, please do not use our services.</p><h2>Definitions</h2><ul><li><strong> 'QRHUB,' 'we,' 'us,' 'our' </strong> refers to the company providing the QRHUB service.</li><li><strong> 'User,' 'you,' 'your' </strong> refers to the individual or entity using our services.</li><li><strong> 'Services' </strong> refers to the QRHUB website, tools, and features provided by us.</li><li><strong> 'Account' </strong> refers to the user account created to access our services.</li></ul><h2>Account Registration and Use</h2><h3>1. Eligibility:</h3><p>You must be at least 18 years old to use our services. By creating an account, you represent that you meet this age requirement.</p><h3>2. Account Creation:</h3><p>To use QRHUB, you must create an account by providing accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials.</p><h3>3. Account Responsibility:</h3><p>You are responsible for all activities that occur under your account. Notify us immediately of any unauthorized access or use of your account.</p><h3>4. Account Suspension:</h3><p>We reserve the right to suspend or terminate your account if you violate these terms or engage in any fraudulent, abusive, or harmful behavior.</p><h2>Use of Services</h2><h3>1. License:</h3><p>QRHUB grants you a limited, non-exclusive, non-transferable license to use our services in accordance with these terms.</p><h3>2. Prohibited Uses:</h3><p>You agree not to:</p><ul><li>Use our services for illegal or unauthorized purposes.</li><li>Interfere with or disrupt the security, integrity, or performance of our services.</li><li>Attempt to gain unauthorized access to any part of our services.</li><li>Upload, post, or share any content that is defamatory, obscene, pornographic, abusive, invasive of privacy, fraudulent, or otherwise objectionable, including content related to sexual material, pornography, politics, or other sensitive topics.</li></ul><h3>3. Content Ownership:</h3><p>You retain ownership of all content you create or upload using our services. By using QRHUB, you grant us a non-exclusive, royalty-free license to use, display, and distribute your content solely for the purpose of providing our services.</p><h3>4. Compliance:</h3><p>You agree to comply with all applicable laws and regulations when using our services.</p><h2>Reporting Inappropriate Content</h2><h3>1. Report Mechanism:</h3><p>If you encounter content that you believe violates our terms, please report it immediately to our support team. We will review the reported content and take appropriate action, which may include removing the content or suspending the account responsible.</p><h3>2. Right to Remove:</h3><p>QRHUB reserves the right to remove any content that violates these terms or is deemed inappropriate, at our sole discretion. We also reserve the right to suspend or terminate accounts that repeatedly violate our policies.</p><h2>Payment and Billing</h2><h3>1. Subscription Plans:</h3><p>QRHUB offers various subscription plans. You agree to pay all fees associated with your chosen plan as described on our website.</p><h3>2. Billing Information:</h3><p>You must provide accurate billing information and update it promptly in case of changes.</p><h3>3. Payment Authorization:</h3><p>By subscribing to a plan, you authorize QRHUB to charge the applicable fees to your provided payment method.</p><h3>4. Refunds:</h3><p>All fees are non-refundable unless otherwise stated in our refund policy.</p><h2>Intellectual Property</h2><h3>1. QRHUB Ownership:</h3><p>QRHUB owns all rights, titles, and interests in and to our services, including but not limited to software, trademarks, and content.</p><h3>2. User Content:</h3><p>You retain ownership of your content. You represent and warrant that you have the necessary rights to upload and share your content via QRHUB.</p><h3>3. Feedback:</h3><p>We welcome feedback and suggestions to improve our services. By submitting feedback, you grant us the right to use and incorporate it without any obligation or compensation.</p><h2>Data Protection and Privacy</h2><h3>1. Privacy Policy:</h3><p>Our Privacy Policy explains how we collect, use, and protect your information. By using QRHUB, you agree to the terms of our Privacy Policy.</p><h3>2. Data Security:</h3><p>We implement reasonable security measures to protect your information. However, you acknowledge that no method of transmission or storage is completely secure.</p><h3>3. Data Processing:</h3><p>By using our services, you consent to the processing of your data as described in our Privacy Policy.</p><h2>Third-Party Services</h2><h3>1. Integrations:</h3><p>QRHUB may integrate with third-party services to enhance functionality. We are not responsible for the actions or content of these third-party services.</p><h3>2. Third-Party Terms:</h3><p>Your use of third-party services is subject to their respective terms and conditions. We encourage you to review these terms before using third-party integrations.</p><h2>Limitation of Liability</h2><h3>1. No Warranty:</h3><p>QRHUB provides services 'as is' and 'as available' without any warranties, express or implied.</p><h3>2. Limitation of Liability:</h3><p>To the fullest extent permitted by law, QRHUB shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.</p><h3>3. Maximum Liability:</h3><p>Our total liability to you for any claim related to our services is limited to the amount you paid us for the service in question.</p><h2>Indemnification</h2><p>You agree to indemnify and hold QRHUB harmless from any claims, losses, liabilities, damages, expenses, or costs (including legal fees) arising from your use of our services, violation of these terms, or infringement of any third-party rights.</p><h2>Termination</h2><h3>1. Termination by You:</h3><p>You may terminate your account at any time by following the instructions in your account settings.</p><h3>2. Termination by QRHUB:</h3><p>We reserve the right to terminate or suspend your account if you breach these terms or engage in any fraudulent or harmful activity.</p><h3>3. Effect of Termination:</h3><p>Upon termination, your right to use our services will cease, and any data associated with your account may be deleted.</p><h2>Governing Law and Dispute Resolution</h2><h3>1. Governing Law:</h3><p>These terms are governed by the laws of the jurisdiction where QRHUB is headquartered, without regard to its conflict of law principles.</p><h3>2. Dispute Resolution:</h3><p>Any disputes arising from these terms shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association.</p><h3>3. Jurisdiction:</h3><p>You agree to submit to the exclusive jurisdiction of the courts located in the United Arab Emirates, for resolving any disputes related to these terms.</p><h2>Changes to These Terms</h2><p>QRHUB reserves the right to update or modify these Terms and Conditions at any time. Any changes will be posted on this page with an updated effective date. Your continued use of our services constitutes acceptance of the revised terms.</p><h2>Contact Us</h2><p>If you have any questions or concerns about these Terms and Conditions, please contact us at <strong> legal@cms.qrhub.io </strong></p>",
    },
    qrhubNoticeForCopyright: {
      id: "1",
      title: "QRHUB Notice for Copyright",
      effectiveDate: "November 15, 2023",
      lastModifiedDate: "November 7, 2023",
      description:
        "<p>QRHUB is committed to respecting and protecting intellectual property rights. This Notice for Copyright outlines the rights and responsibilities related to the content available on our website and services. By accessing or using QRHUB, you agree to comply with this notice.</p><h2>Copyright Ownership</h2><h3>1. QRHUB Content:</h3><p>All content available on QRHUB, including but not limited to text, graphics, logos, images, videos, software, and design elements, is the property of QRHUB and is protected by copyright laws.</p><h3>2. Trademarks:</h3><p>QRHUB&rsquo;s trademarks, service marks, and logos are the exclusive property of QRHUB. Unauthorized use of these marks is prohibited.</p><h3>3. User-Generated Content:</h3><p>Users retain ownership of any content they create or upload to QRHUB. By posting content, you grant QRHUB a non-exclusive, royalty-free license to use, display, and distribute your content as part of our services.</p><h2>Permitted Use</h2><h3>1. Personal Use:</h3><p>You may access and use QRHUB content for personal, non-commercial purposes. You may not modify, reproduce, distribute, or create derivative works from any content without explicit permission from QRHUB.</p><h3>2. Sharing Content:</h3><p>You may share QRHUB content using the provided sharing tools, provided that you do not remove or alter any copyright notices or proprietary rights markings.</p><h3>3. Educational Use:</h3><p>Educational institutions may use QRHUB content for instructional purposes, provided they obtain permission and give appropriate credit to QRHUB.</p><h2>Prohibited Use</h2><h3>1. Commercial Use:</h3><p>Unauthorized commercial use of QRHUB content is strictly prohibited. This includes selling, licensing, or redistributing content for commercial purposes without explicit permission.</p><h3>2. Modification:</h3><p>You may not modify, alter, or adapt QRHUB content without permission. This includes creating derivative works or incorporating our content into other media.</p><h3>3. Infringement:</h3><p>Any unauthorized use of QRHUB content that infringes upon our copyrights or violates these terms may result in legal action.</p><h2>Reporting Copyright Infringement</h2><h3>1. Notice and Takedown:</h3><p>If you believe that any content on QRHUB infringes upon your copyright, please notify us immediately. We will investigate and take appropriate action, including removing infringing content if necessary.</p><h3>2. DMCA Compliance:</h3><p>QRHUB complies with the Digital Millennium Copyright Act (DMCA). Please provide a written notice containing the following information:</p><ul><li>A description of the copyrighted work you believe has been infringed.</li><li>A description of where the infringing content is located on QRHUB.</li><li>Your contact information, including name, address, phone number, and email address.</li><li>A statement affirming your good faith belief that the use is unauthorized.</li><li>A statement affirming the accuracy of your notice, under penalty of perjury, and your authority to act on behalf of the copyright owner.</li><li>Your physical or electronic signature.</li></ul><h3>3. Counter-Notification:</h3><p>If you believe your content was removed in error, you may submit a counter-notification. This should include:</p><ul><li>Your contact information, including name, address, phone number, and email address.</li><li>A description of the removed content and its location prior to removal.</li><li>A statement under penalty of perjury that you have a good faith belief that the content was removed in error.</li><li>Your consent to the jurisdiction of the federal court in your area and your consent to service of process from the complainant.</li><li>Your physical or electronic signature.</li><li>Contact Information for Notices: legal@cms.qrhub.io</li></ul><h2>Enforcement</h2><p>QRHUB reserves the right to take appropriate legal action against users who violate this Notice for Copyright. This may include suspending or terminating user accounts, removing infringing content, and pursuing legal remedies.</p><h2>Changes to This Notice for Copyright</h2><p>QRHUB reserves the right to update or modify this Notice for Copyright at any time. Any changes will be posted on this page with an updated effective date. Your continued use of our services constitutes acceptance of the revised notice.</p><h2>Contact Us</h2><p>If you have any questions or concerns about this Notice for Copyright, please contact us at legal@cms.qrhub.io</p>",
    },
    qrhubDisclaimers: {
      id: "2",
      title: "QRHUB Disclaimers",
      effectiveDate: "November 15, 2023",
      lastModifiedDate: "November 7, 2023",
      description:
        "<p>Welcome to QRHUB. The information provided on our website and services is for general informational purposes only. By using QRHUB, you agree to the following disclaimers and acknowledge that you understand the limitations of our liability.</p><h2>General Disclaimers</h2><h3>1. No Professional Advice:</h3><p>The content provided by QRHUB is not intended to constitute professional advice or recommendations. We do not guarantee the accuracy, completeness, or suitability of the information for your specific needs. Always seek the advice of a qualified professional before making any decisions based on our content.</p><h3>2. Service Availability:</h3><p>QRHUB strives to maintain the availability and performance of our services. However, we do not guarantee uninterrupted access to our website or services. Service disruptions, delays, or interruptions may occur due to maintenance, technical issues, or factors beyond our control.</p><h3>3. No Warranties:</h3><p>QRHUB provides services on an 'as is' and 'as available' basis. We disclaim all warranties, express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that our services will meet your requirements or that they will be error-free or secure.</p><h2>Content Disclaimers</h2><h3>1. User-Generated Content:</h3><p>QRHUB may contain user-generated content that reflects the views and opinions of individual users. We do not endorse, verify, or guarantee the accuracy of such content. You acknowledge that any reliance on user-generated content is at your own risk.</p><h3>2. Third-Party Links:</h3><p>QRHUB may include links to third-party websites or services. These links are provided for your convenience and do not constitute an endorsement or recommendation by QRHUB. We are not responsible for the content, privacy policies, or practices of third-party sites.</p><h2>Limitation of Liability</h2><h3>1. Indirect Damages:</h3><p>To the fullest extent permitted by law, QRHUB shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services, even if we have been advised of the possibility of such damage.</p><h3>2. Direct Damages:</h3><p>QRHUB's total liability for direct damages arising from your use of our services is limited to the amount you paid us for the service in question.</p><h3>3. Assumption of Risk:</h3><p>By using QRHUB, you assume all risks associated with the use of our services, including any damage to your computer system or data loss resulting from your access to our website or services.</p><h2>Legal Compliance</h2><h3>1. Jurisdiction:</h3><p>QRHUB operates from [Location], and our services are governed by the laws of this jurisdiction. You are responsible for ensuring that your use of QRHUB complies with applicable local laws.</p><h3>2. International Users:</h3><p>If you access QRHUB from outside [Location], you do so at your own risk and are responsible for compliance with local laws. QRHUB makes no representations regarding the legality or availability of our services in other jurisdictions.</p><h2>Changes to This Disclaimers Page</h2><p>QRHUB reserves the right to update or modify these disclaimers at any time. Any changes will be posted on this page with an updated effective date. Your continued use of our services constitutes acceptance of the revised disclaimers.</p><h2>Contact Us</h2><p>If you have any questions or concerns about these disclaimers, please contact us at legal@cms.qrhub.io</p>",
    },
    qrhubRefundPolicy: {
      id: "3",
      title: "QRHUB Refund Policy",
      effectiveDate: "November 15, 2023",
      lastModifiedDate: "November 7, 2023",
      description:
        "<p>Thank you for choosing QRHUB! We strive to provide exceptional services and ensure your satisfaction. This Refund Policy outlines the conditions under which you may request a refund for services purchased through QRHUB. By using our services, you agree to this Refund Policy. If you do not agree, please refrain from using our services.</p><h2>Eligibility for Refunds</h2><h3>1. Subscription Plans:</h3><p>QRHUB offers various subscription plans. Refunds are generally not available for subscription fees once the service period has started.</p><h3>2. Initial Purchase Guarantee:</h3><p>We offer a 14-day money-back guarantee for new subscribers on their initial purchase. If you are not satisfied with our service, you may request a refund within 14 days of the initial purchase date.</p><h3>3. Automatic Renewals:</h3><p>Subscription plans may automatically renew at the end of each billing cycle. Refunds are not available for renewal charges. To avoid automatic renewals, you must cancel your subscription before the renewal date.</p><h3>4. Promotional Offers:</h3><p>Refunds for services purchased during promotional offers are subject to the terms of the promotion. Please review the specific terms associated with any promotional offer before purchase.</p><h2>Requesting a Refund</h2><p>To request a refund, please follow these steps:</p><h3>1. Contact Support:</h3><p>Email our support team at support@cms.qrhub.io with your refund request. Include your account details, order number, and the reason for the refund request.</p><h3>2. Refund Review:</h3><p>Our support team will review your request and may ask for additional information if needed. We aim to respond to refund requests within 5-7 business days.</p><h3>3. Refund Approval:</h3><p>If your refund request is approved, we will process the refund to your original payment method within 10 business days. Please note that processing times may vary depending on your financial institution.</p><h2>Non-Refundable Services</h2><p>Certain services are non-refundable, including:</p><h3>1. Custom Development Services:</h3><p>Fees for custom QR code development or other bespoke services are non-refundable once the service has been rendered.</p><h3>2. One-Time Fees:</h3><p>Any one-time setup or activation fees are non-refundable.</p><h2>Exceptions</h2><h3>1. Service Disruptions:</h3><p>If a significant service disruption occurs, preventing you from accessing QRHUB for an extended period, we may offer a pro-rata refund or credit towards future services.</p><h3>2. Billing Errors:</h3><p>In the event of a billing error, please contact us immediately. We will investigate the issue and provide a refund or credit if warranted.</p><h2>Cancellations</h2><h3>1. Subscription Cancellations:</h3><p>You can cancel your subscription at any time through your account settings. Cancellation will take effect at the end of the current billing cycle, and you will not be charged for subsequent periods.</p><h3>2. Effect of Cancellation:</h3><p>Upon cancellation, you will retain access to QRHUB services until the end of the current billing cycle. No refunds will be issued for unused portions of a billing cycle.</p><h2>Changes to This Refund Policy</h2><p>QRHUB reserves the right to update or modify this Refund Policy at any time. Any changes will be posted on this page with an updated effective date. Your continued use of our services constitutes acceptance of the revised policy.</p><h2>Contact Us</h2><p>If you have any questions or concerns about this Refund Policy, please contact us.</p>",
    },
    qrhubPrivacyPolicy: {
      id: "3",
      title: "QRHUB Privacy Policy",
      effectiveDate: "November 15, 2023",
      lastModifiedDate: "November 7, 2023",
      description:
        "<h2>Welcome to QRHUB!</h2><p>At QRHUB, your privacy is our priority. As a leading SaaS provider of QR code solutions, we are committed to safeguarding your personal information and being transparent about how we handle it. This Privacy Policy explains our practices regarding the collection, use, and sharing of your information when you use our website and services. <br /> By accessing or using QRHUB, you agree to the terms of this Privacy Policy. If you do not agree, please do not use our services.</p><h2>Information We Collect</h2><p>We collect various types of information to provide and improve our services for you:</p><h3>1. Personal Information</h3><p>When you create an account or interact with QRHUB, we may collect personal information such as:</p><ul><li><strong> Contact Information: </strong> Name, email address, phone number, and other details you provide.</li><li><strong> Profile Information: </strong> Data included in your vCard, such as job title, company, social media links, and avatar.</li><li><strong> Payment Information: </strong> Billing address and payment details for purchases made through our services.</li></ul><h3>2. Usage Data</h3><p>We collect information about how you use our services, including:</p><ul><li><strong> QR Code Interactions: </strong> Data on your QR code creations, scans, and interactions.</li><li><strong> Website Activity: </strong> Pages visited, time spent on our site, and clickstream data.</li><li><strong> Service Performance: </strong> Data on service reliability, issues, and usage patterns to enhance performance.</li></ul><h3>3. Technical Information</h3><p>To enhance your experience, we collect technical data such as:</p><ul><li><strong> Device Information: </strong> IP address, browser type, operating system, and device identifiers.</li><li><strong> Cookies and Tracking Technologies: </strong> We use cookies to improve functionality and personalize your experience. You can control cookie settings through your browser.</li></ul><h2>How We Use Your Information</h2><p>QRHUB uses your information to:</p><h3>1. Provide and Enhance Services</h3><ul><li><strong> Account Management: </strong> Create and maintain your account, generate QR codes, and offer personalized features.</li><li><strong> Improve Functionality: </strong> Analyze usage patterns to enhance user experience, service performance, and reliability.</li><li><strong> Integrations: </strong> Manage third-party integrations and API interactions for enhanced service offerings.</li></ul><h3>2. Communicate with You</h3><ul><li><strong> Notifications and Updates: </strong> Send service-related announcements, promotional materials, and respond to inquiries.</li><li><strong> Support: </strong> Provide customer support and resolve technical issues.</li></ul><h3>3. Ensure Security and Compliance</h3><ul><li><strong> Security Measures: </strong> Implement robust security practices to protect against unauthorized access, fraud, and malicious activities.</li><li><strong> Legal Compliance: </strong> Comply with applicable laws, regulations, and legal requests.</li></ul><h2>Sharing Your Information</h2><p>QRHUB respects your privacy and only shares information as necessary:</p><h3>1. Service Providers</h3><p>We partner with trusted third-party service providers to assist in operating our website and delivering services. These providers are bound by confidentiality agreements and are not allowed to use your information for other purposes.</p><h3>2. Legal Obligations</h3><p>We may disclose information to comply with legal obligations, enforce our terms and conditions, and protect our rights and interests.</p><h3>3. Business Transfers</h3><p>In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the business transition.</p><h2>Your Choices and Rights</h2><p>QRHUB offers you control over your personal information:</p><h3>1. Access and Update</h3><p>You can access and update your personal information through your account settings. If you need assistance, contact our support team.</p><h3>2. Opt-Out</h3><p>You can opt out of receiving promotional communications by following the unsubscribe instructions in emails. Please note that you may still receive transactional or service-related communications.</p><h3>3. Manage Cookies</h3><p>You can manage cookie preferences through your browser settings, including blocking or deleting cookies.</p><h2>Data Security</h2><p>We implement robust security measures to protect your information. Our practices include encryption, access controls, and regular security audits. However, no method of transmission or electronic storage is 100% secure. We encourage you to use unique passwords and maintain the security of your account credentials.</p><h2>Data Retention and Deletion</h2><p>QRHUB retains your information as long as necessary to provide services and fulfill legal obligations. You can request data deletion through your account settings, and we will respond promptly in accordance with applicable laws.</p><h2>International Data Transfers</h2><p>QRHUB operates globally, and your information may be transferred to countries outside your own. We ensure that such transfers comply with applicable data protection laws and take necessary steps to protect your information.</p><h2>Compliance and Certifications</h2><p>QRHUB adheres to industry standards and regulations, including GDPR and CCPA. For questions related to compliance, please contact our Data Protection Officer at legal@cms.qrhub.io</p><h2>Children&rsquo;s Privacy</h2><p>QRHUB does not knowingly collect personal information from children under the age of 13. If you believe we have collected information from a child, please contact us immediately.</p><h2>Changes to This Privacy Policy</h2><p>We may update this Privacy Policy periodically. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy regularly to stay informed about our data practices.</p><h2>Contact Us</h2><p>If you have questions or concerns about this Privacy Policy, please contact us at legal@cms.qrhub.io</p>",
    },
    qrhubCookiesPolicy: {
      id: "4",
      title: "QRHUB Cookies Policy",
      effectiveDate: "November 15, 2023",
      lastModifiedDate: "November 7, 2023",
      description:
        "<p>At QRHUB, we are committed to ensuring your privacy and providing transparency about how we use cookies and similar technologies. This Cookies Policy explains what cookies are, how we use them, and how you can manage your preferences. By using QRHUB's website and services, you consent to the use of cookies in accordance with this policy.</p><h2>What Are Cookies?</h2><p>Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. They are widely used to enhance your browsing experience by remembering your preferences, improving site functionality, and providing insights into how our site is used.</p><h2>Types of Cookies We Use</h2><p>QRHUB uses the following types of cookies:</p><h3>Essential Cookies</h3><p>These cookies are necessary for the basic functioning of our website and services. They enable core features such as account login, navigation, and secure access to protected areas. Without these cookies, our services would not function properly.</p><h3>Performance Cookies</h3><p>Performance cookies collect information about how visitors use our website, such as which pages are visited most frequently and any error messages received. These cookies help us improve the performance and reliability of our site, ensuring a better user experience.</p><ul><li><strong> Example: </strong> Analytics cookies that provide insights into website traffic and visitor behavior.</li></ul><h3>Functional Cookies</h3><p>Functional cookies enable our website to remember choices you make and provide enhanced features. These may include remembering your login details, language preferences, or other customizations.</p><ul><li><strong> Example: </strong> Remembering your preferred language setting or saved QR code templates.</li></ul><h3>Targeting and Advertising Cookies</h3><p>These cookies are used to deliver relevant advertisements to you and measure the effectiveness of our marketing campaigns. They may also limit the number of times you see an advertisement and help us understand your interests based on your browsing habits.</p><ul><li><strong> Example: </strong> Cookies that track your interactions with our marketing emails and ads.</li></ul><h3>Third-Party Cookies</h3><p>QRHUB uses third-party cookies from service providers who assist us in improving our website and services. These providers may use cookies to deliver targeted advertisements, analyze website traffic, and understand user interactions.</p><ul><li><strong> Examples: </strong></li></ul><ul><ul><li><strong> Google Analytics: </strong> Used for tracking website usage and generating reports on user interactions. Google Privacy Policy</li><li><strong> Facebook Pixel: </strong> Utilized for tracking the effectiveness of our advertising across Facebook. <a href='https://www.facebook.com/policy.php'> Facebook Privacy Policy </a></li><li><strong> LinkedIn Insights: </strong> Helps measure the impact of our LinkedIn advertising campaigns. <a href='https://www.linkedin.com/legal/privacy-policy'> LinkedIn Privacy Policy </a></li></ul></ul><h2>How We Use Cookies</h2><p>QRHUB uses cookies to:</p><ul><li><strong> Enhance User Experience: </strong> Provide personalized content and save user preferences for a seamless experience.</li><li><strong> Analyze Usage: </strong> Understand how our website is used and identify areas for improvement.</li><li><strong> Deliver Targeted Content: </strong> Show relevant advertisements and promotions based on your interests.</li><li><strong> Secure Transactions: </strong> Protect your information and ensure secure access to our services.</li></ul><h2>Managing Your Cookie Preferences</h2><p>You have the right to manage your cookie preferences and can choose to disable certain types of cookies. Here&rsquo;s how you can control cookies:</p><h2>Browser Settings</h2><p>Most web browsers allow you to manage your cookie settings. You can set your browser to refuse cookies, delete existing cookies, or notify you when cookies are set. However, disabling cookies may affect the functionality of our website and services.</p><p>Here are some links to manage cookies in popular browsers:</p><ul><li><strong> Google Chrome: </strong> <a href='https://support.google.com/chrome/answer/95647?hl=en&amp;co=GENIE.Platform%3DDesktop'> Manage cookies in Chrome </a></li><li><strong> Mozilla Firefox: </strong> <a href='https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox'> Manage cookies in Firefox </a></li><li><strong> Microsoft Edge: </strong> <a href='https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d'> Manage cookies in Edge </a></li><li><strong> Safari: </strong> <a href='https://support.apple.com/en-us/105082'> Manage cookies in Safari </a></li></ul><h2>Cookie Consent Tool</h2><p>QRHUB provides a cookie consent tool on our website, allowing you to customize your cookie preferences. You can choose to accept or reject specific types of cookies based on your preferences.</p><h2>Opt-Out Options</h2><p>For third-party cookies related to advertising, you may opt out through industry opt-out platforms such as:</p><ul><li><strong> Network Advertising Initiative (NAI): </strong> www.networkadvertising.org/choices</li><li><strong> Digital Advertising Alliance (DAA): </strong> www.aboutads.info/choices</li><li><strong> European Interactive Digital Advertising Alliance (EDAA): </strong> <a href='http://www.youronlinechoices.eu/'> www.youronlinechoices.eu </a></li></ul><h2>Changes to This Cookies Policy</h2><p>QRHUB may update this Cookies Policy periodically to reflect changes in technology or legal requirements. Any updates will be posted on this page with an updated effective date. We encourage you to review this policy regularly to stay informed about our cookie practices.</p><h2>Contact Us</h2><p>If you have questions or concerns about this Cookies Policy, please contact us.</p><h2>Feedback</h2><p>We value your feedback regarding our cookie practices. Please let us know if you have any suggestions or concerns about our Cookies Policy at legal@cms.qrhub.io</p>",
    },
    qrhubTrademarksPatentsAndCorporatePolicies: {
      id: "5",
      title: "QRHUB Trademarks, Patents & Corporate Policies",
      effectiveDate: "November 15, 2023",
      lastModifiedDate: "November 7, 2023",
      description:
        "<p>QRHUB is committed to protecting its intellectual property and maintaining high standards of corporate governance. This page outlines our trademarks, patents, and key corporate policies. By accessing QRHUB, you agree to comply with these terms and recognize our intellectual property rights.</p><h2>Trademarks</h2><h3>1. QRHUB Trademarks:</h3><p>The name 'QRHUB,' our logo, and other branding elements are registered trademarks of QRHUB. These marks represent our brand identity and are protected by trademark laws.</p><h3>2. Use of Trademarks:</h3><p>Unauthorized use of QRHUB trademarks is prohibited. You may not use our trademarks in any manner that suggests affiliation, endorsement, or sponsorship without explicit permission from QRHUB.</p><h3>3. Permission Requests:</h3><p>If you wish to use QRHUB trademarks for any purpose, please contact us for permission. Unauthorized use may result in legal action.</p><h2>Patents</h2><h3>1. Patent Rights:</h3><p>QRHUB may hold patents or patent-pending technologies related to our services and products. Our patents protect our innovations and technological advancements.</p><h3>2. Patent Infringement:</h3><p>Unauthorized use of QRHUB's patented technologies is prohibited. Infringement of our patents may result in legal action.</p><h3>3. Patent Licensing:</h3><p>If you are interested in licensing QRHUB's patented technologies, please contact us for further information.</p><h2>Corporate Policies</h2><h3>1. Code of Conduct:</h3><p>QRHUB is committed to ethical business practices. Our Code of Conduct outlines the principles and standards that guide our employees, partners, and stakeholders.</p><h3>2. Privacy Policy:</h3><p>Our Privacy Policy details how we collect, use, and protect personal information. We are committed to safeguarding your privacy and ensuring compliance with applicable data protection laws.</p><h3>3. Environmental Policy:</h3><p>QRHUB is dedicated to minimizing our environmental impact. We strive to implement sustainable practices and reduce our carbon footprint in all aspects of our operations.</p><h3>4. Diversity and Inclusion:</h3><p>We value diversity and inclusion in our workplace and communities. QRHUB is committed to fostering an environment that respects and embraces differences in backgrounds, perspectives, and experiences.</p><h3>5. Anti-Corruption Policy:</h3><p>QRHUB has a zero-tolerance policy for corruption and bribery. We are committed to conducting business with integrity and transparency, in compliance with all applicable anti-corruption laws.</p><h2>Reporting Violations</h2><h3>1. Trademark or Patent Violations:</h3><p>If you suspect any unauthorized use of QRHUB's trademarks or patents, please report it to us immediately. We will investigate and take appropriate action.</p><h3>2. Corporate Policy Violations:</h3><p>If you witness any violations of QRHUB's corporate policies, please report them to our compliance team. We are committed to addressing all reports with confidentiality and integrity.</p><h2>Legal Actions</h2><p>QRHUB reserves the right to take legal action to protect our intellectual property rights and enforce our corporate policies. This may include seeking injunctions, damages, or other legal remedies.</p><h2>Changes to This Page</h2><p>QRHUB reserves the right to update or modify this page at any time. Any changes will be posted here with an updated effective date. Your continued use of our services constitutes acceptance of the revised terms.</p><h2>Contact Us</h2><p>If you have any questions or concerns about our trademarks, patents, or corporate policies, please contact us at legal@cms.qrhub.io</p>",
    },
    qrhubCommentPolicy: {
      id: "6",
      title: "QRHUB Comment Policy",
      effectiveDate: "November 15, 2023",
      lastModifiedDate: "November 7, 2023",
      description:
        "<p>QRHUB is committed to fostering a respectful and engaging community where users can share insights and ideas about our services and QR code solutions. This Comment Policy outlines the guidelines for posting comments on our website, blog, and social media platforms. By posting a comment, you agree to comply with this policy.</p><h2>Guidelines for Commenting</h2><h3>1. Be Respectful</h3><ul><li><strong> Treat all members of the community with respect. </strong> Avoid using language or tone that is offensive, discriminatory, or inflammatory.</li><li><strong> Example: </strong> Instead of saying, &ldquo;This is a terrible idea!&rdquo; try, &ldquo;I have some concerns about this approach and would like to discuss alternatives.&rdquo;</li></ul><h3>2. Stay On Topic</h3><ul><li><strong> Ensure your comments are relevant to the content or discussion. </strong> Off-topic comments may be removed to maintain the focus of the conversation.</li><li><strong> Example: </strong> If the post is about QR code security features, focus on discussing security rather than unrelated topics.</li></ul><h3>3. No Hate Speech or Bullying</h3><ul><li><strong> Comments that include hate speech, threats, or harassment of any kind will not be tolerated and will be removed. </strong></li><li><strong> Example: </strong> Personal attacks on other users or discriminatory language are strictly prohibited.</li></ul><h3>4. No Spam or Self-Promotion</h3><ul><li><strong> Refrain from posting spam, promotional content, or links to external websites. </strong> Comments intended for self-promotion will be removed.</li><li><strong> Example: </strong> Sharing affiliate links or advertisements for unrelated products or services is not allowed.</li></ul><h3>5. Protect Privacy</h3><ul><li><strong> Do not post personal information, such as phone numbers, email addresses, or home addresses, for yourself or others. </strong></li><li><strong> Example: </strong> If discussing a business scenario, use general examples without disclosing sensitive details.</li></ul><h3>6. Use Appropriate Language</h3><ul><li><strong> Avoid using profanity or obscene language. </strong> We encourage a family-friendly environment where all ages can participate.</li><li><strong> Example: </strong> Choose respectful and polite language to express your thoughts.</li></ul><h3>7. Contribute Constructively</h3><ul><li><strong> Aim to add value to the discussion by sharing insights, asking questions, and providing constructive feedback. </strong></li><li><strong> Example: </strong> Suggesting improvements or asking thoughtful questions can enhance the conversation.</li></ul><h3>8. Respect Intellectual Property</h3><ul><li><strong> Ensure that any content you share is your original work or properly attributed to the original creator. </strong></li><li><strong> Example: </strong> If quoting a source, provide proper attribution and avoid plagiarism.</li></ul><h2>Moderation Process</h2><h3>1. Comment Review</h3><ul><li><strong> QRHUB reserves the right to review, edit, or delete any comments that violate this policy. </strong> Comments are subject to moderation to ensure compliance with our guidelines.</li></ul><h3>2. Reporting Violations</h3><ul><li><strong> If you encounter a comment that violates this policy, please report it to our moderation team at (comments@cms.qrhub.io). </strong></li></ul><h3>3. Consequences of Violation</h3><ul><li><strong> Users who repeatedly violate this policy may have their commenting privileges suspended or revoked. </strong> Severe violations may result in a ban from our platforms.</li></ul><h3>4. Feedback and Appeals</h3><ul><li><strong> If you believe your comment was removed in error, you may contact our support team for clarification or to appeal the decision. </strong></li></ul><p>&nbsp;</p><h2>User Responsibilities</h2><h3>1. Accountability</h3><ul><li><strong> You are responsible for the content of your comments. </strong> Ensure your contributions align with our guidelines and reflect positively on the community.</li></ul><h3>2. Engagement</h3><ul><li><strong> We encourage thoughtful and respectful engagement. </strong> Please take the time to read comments and respond appropriately to foster a positive discussion environment.</li></ul><h2>Changes to This Comment Policy</h2><p>QRHUB reserves the right to update or modify this Comment Policy at any time. Any changes will be posted on this page with an updated effective date. Your continued participation in our community constitutes acceptance of the revised policy.</p><h2>Contact Us</h2><p>If you have any questions or concerns about this Comment Policy, please contact us.</p>",
    },
  },
  legalPagesSidebarLeft: {
    lists: {
      list_0: {
        id: "0",
        maintitle: "Legal",
        items: {
          item_0: {
            title: "QRHUB Terms & Conditions",
            url: "/en/qrhub-terms-and-conditions/",
          },
          item_1: {
            title: "QRHUB Privacy Policy",
            url: "/en/qrhub-privacy-policy/",
          },
          item_2: {
            title: "QRHUB Disclaimers",
            url: "/en/qrhub-disclaimers/",
          },
          item_3: {
            title: "QRHUB Comment Policy",
            url: "/en/qrhub-comment-policy/",
          },
          item_4: {
            title: "QRHUB Cookies Policy",
            url: "/en/qrhub-cookies-policy/",
          },
          item_5: {
            title: "QRHUB Notice For Copyright",
            url: "/en/qrhub-notice-for-copyright/",
          },
          item_6: {
            title: "QRHUB Refund Policy",
            url: "/en/qrhub-refund-policy/",
          },
          item_7: {
            title: "QRHUB Trademarks Patents & Corporate Policies",
            url: "/en/qrhub-trademarks-patents-and-corporate-policies/",
          },
        },
      },
    },
  },
  productsPage: {
    ourProducts: {
      vCard: {
        title: "vCard",
        description:
          "Generate a static vCard QR code for easy sharing of your professional details. Perfect for networking events, conferences, or business meetings, offering a quick way for others to save your contact information.",
        shortDesc: "Share contact details seamlessly.",
        url: "",
        staticUrl: "/",
      },
      vCardPlus: {
        title: "vCard Plus",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Share contact details seamlessly.",
        url: "/en/products/qr-vcard-plus/",
        staticUrl: "/",
      },
      landingPage: {
        title: "Landing Page",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Drive traffic to custom landing pages.",
        url: "/en/products/qr-landing-page/",
      },
      fileLink: {
        title: "File Link",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Link to documents quickly.",
        url: "",
      },
      imageGallery: {
        title: "Image Gallery",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Showcase images in a QR gallery.",
        url: "/en/products/qr-image-gallery/",
      },
      listOfFiles: {
        title: "List of Files",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Link to documents quickly.",
        url: "/en/products/qr-list-of-files/",
      },
      directLink: {
        title: "Direct Link",
        description:
          "Create static QR codes that direct users to a specific URL effortlessly. Ideal for websites, portfolios, or any web content, ensuring a quick and reliable navigation experience every time.",
        shortDesc: "Direct to any URL.",
        url: "",
        staticUrl: "/",
      },
      dynamicLink: {
        title: "Dynamic Link",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Direct to any URL.",
        url: "/en/products/qr-dynamic-link/",
        staticUrl: "",
      },
      listOfLinks: {
        title: "List of Links",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Organize multiple links in one QR code.",
        url: "/en/products/qr-list-of-links/",
      },
      businessProfile: {
        title: "Business Profile",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Share comprehensive business information.",
        url: "/en/products/qr-business-profile/",
      },
      wifi: {
        title: "Wi-Fi",
        description:
          "Make Wi-Fi sharing convenient with a static QR code. Allow users to connect securely and quickly without manually entering credentials—ideal for cafes, offices, and public spaces.",
        shortDesc: "Share wifi access",
        url: "",
        staticUrl: "/",
      },
      videoPlaylist: {
        title: "Video Playlist",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "QR Video Playlist.",
        url: "/en/products/qr-video-playlist/",
      },
      appLinks: {
        title: "App Links",
        description:
          "Dui nec vel donec neque tristique faucibus varius. Nulla placerat eu vehicula facilisis egestas. Accumsan lectus dui interdum ultrices facilisi condimentum ullamcorper egestas diam. Donec consectetur gravida vitae massa ultricies at sed enim. Proin elit enim ",
        shortDesc: "Direct to any URLs.",
        url: "/en/products/qr-app-links/",
      },
    },
    staticVsDynamic: {
      static: {
        title: "Static QR Codes",
        description:
          "Static QR codes have fixed content, no tracking, limited storage, lack security features, and best suited for simple, unchanging information.",
        advantages: {
          item_0: {
            title: "Inability to Update Content",
            desc: "Once a static QR code is generated, the information encoded within it cannot be changed. If you need to update the linked content or correct an error, you must create a new QR code.",
          },
          item_1: {
            title: "No Tracking and Analytics",
            desc: "Static QR codes do not offer the ability to track usage metrics such as the number of scans, the location of scans, or the type of device used. This makes it difficult to measure the effectiveness of a marketing campaign or gather user insights.",
          },
          item_2: {
            title: "Larger Size for Complex Data",
            desc: "When encoding large amounts of data (e.g., long URLs, detailed text), static QR codes require more complex patterns, leading to a larger and more visually dense code. This can make the code harder to scan and less aesthetically pleasing.",
          },
          item_3: {
            title: "Security Risks",
            desc: "Since the content of a static QR code cannot be changed, any error or malicious link embedded within it remains fixed. If a static QR code is compromised, you would need to replace the entire code, which can be costly and inconvenient.",
          },
          item_4: {
            title: "Limited Functionality",
            desc: "Static QR codes are generally used for simple tasks like linking to a URL or providing text information. They cannot be used for more advanced functions such as password protection, A/B testing, or retargeting users.",
          },
          item_5: {
            title: "No Customization",
            desc: "Static QR codes are less flexible in terms of customization. While the design can be modified to some extent, the encoded information itself is fixed and cannot be tailored for different user groups or campaigns.",
          },
        },
        features: {
          featureDesc:
            "Static QR codes have several disadvantages compared to dynamic QR codes:",
          lists: {
            item_0: {
              desc: "<strong>Inability to Update Content:</strong> Once a static QR code is generated, the information encoded within it cannot be changed. If you need to update the linked content or correct an error, you must create a new QR code.",
            },
            item_1: {
              desc: "<strong>Limited Tracking and Analytics:</strong> Static QR codes do not offer the ability to track usage metrics such as the number of scans, the location of scans, or the type of device used. This makes it difficult to measure the effectiveness of a marketing campaign or gather user insights.",
            },
            item_2: {
              desc: "<strong>Larger Size for Complex Data:</strong> When encoding large amounts of data (e.g., long URLs, detailed text), static QR codes require more complex patterns, leading to a larger and more visually dense code. This can make the code harder to scan and less aesthetically pleasing..",
            },
            item_3: {
              desc: "<strong>Security Risks:</strong> Since the content of a static QR code cannot be changed, any error or malicious link embedded within it remains fixed. If a static QR code is compromised, you would need to replace the entire code, which can be costly and inconvenient.",
            },
            item_4: {
              desc: "<strong>Limited Functionality:</strong> Static QR codes are generally used for simple tasks like linking to a URL or providing text information. They cannot be used for more advanced functions such as password protection, A/B testing, or retargeting users.",
            },
            item_5: {
              desc: "<strong>No Customization:</strong> Static QR codes are less flexible in terms of customization. While the design can be modified to some extent, the encoded information itself is fixed and cannot be tailored for different user groups or campaigns.",
            },
          },
          text: "These limitations make static QR codes less suitable for applications where flexibility, real-time updates, and data tracking are important.",
        },
      },
      dynamic: {
        title: "Dynamic QR Codes",
        description:
          "Dynamic QR codes allow content updates, track analytics, support complex data, offer password protection, and use shorter URLs.",
        advantages: {
          item_0: {
            title: "Editable Content",
            desc: "The most significant advantage of dynamic QR codes is the ability to edit the content after the code has been generated. This means you can update the URL or information linked to the QR code without needing to reprint the code itself.",
          },
          item_1: {
            title: "Analytics Tracking",
            desc: "Dynamic QR codes can provide detailed analytics, including the number of scans, the location of scans, the time of day, and the type of device used. This data is valuable for measuring the effectiveness of marketing campaigns and understanding user behavior.",
          },
          item_2: {
            title: "Reduced Size and Complexity",
            desc: "Dynamic QR codes often encode a short redirect URL rather than the full data, resulting in a simpler and less dense QR code. This makes the code easier to scan and more visually appealing.",
          },
          item_3: {
            title: "High Security",
            desc: "Dynamic QR codes can include security features such as password protection, expiration dates, and limited access. This makes them suitable for sensitive information or time-bound campaigns.",
          },
          item_4: {
            title: "Flexibility in Use",
            desc: "Dynamic QR codes can be used for various purposes, such as linking to websites, sending SMS messages, making phone calls, or downloading apps. The ability to change the content allows businesses to use the same QR code for different campaigns over time.",
          },
          item_5: {
            title: "Retargeting and Customization",
            desc: "You can use dynamic QR codes to retarget users based on their scanning behavior. Additionally, the content can be personalized for different user groups, enhancing the user experience.",
          },
        },
        features: {
          featureDesc:
            "Dynamic QR codes offer several advantages over static QR codes, making them more versatile and useful in various applications:",
          lists: {
            item_0: {
              desc: "<strong>Editable Content:</strong> The most significant advantage of dynamic QR codes is the ability to edit the content after the code has been generated. This means you can update the URL or information linked to the QR code without needing to reprint the code itself.",
            },
            item_1: {
              desc: "<strong>Tracking and Analytics:</strong> Dynamic QR codes can provide detailed analytics, including the number of scans, the location of scans, the time of day, and the type of device used. This data is valuable for measuring the effectiveness of marketing campaigns and understanding user behavior.",
            },
            item_2: {
              desc: "<strong>Reduced Size and Complexity:</strong> Dynamic QR codes often encode a short redirect URL rather than the full data, resulting in a simpler and less dense QR code. This makes the code easier to scan and more visually appealing.",
            },
            item_3: {
              desc: "<strong>Security Features:</strong> Dynamic QR codes can include security features such as password protection, expiration dates, and limited access. This makes them suitable for sensitive information or time-bound campaigns.",
            },
            item_4: {
              desc: "<strong>Retargeting and Customization:</strong> You can use dynamic QR codes to retarget users based on their scanning behavior. Additionally, the content can be personalized for different user groups, enhancing the user experience.",
            },
            item_5: {
              desc: "<strong>Flexibility in Use:</strong> Dynamic QR codes can be used for various purposes, such as linking to websites, sending SMS messages, making phone calls, or downloading apps. The ability to change the content allows businesses to use the same QR code for different campaigns over time.",
            },
          },
          text: "These advantages make dynamic QR codes particularly useful for businesses and organizations that need flexibility, detailed analytics, and the ability to update information frequently.",
        },
      },
    },
  },
  homePage: {
    dynamicSection: {
      title: "DYNAMIC",
      subTitle: "MICRO-SERVICES",
      buttonTitle: "Show More",
      buttonUrl: "/en/",
    },
    signUpSection: {
      title: "Ready to Get Started?",
      subTitle: "Sign up now and create your first QR code for free!",
      buttonTitle: "Sign Up Now",
      buttonUrl: "/en/",
      leftPhone: "/images/signUpSection/left.webp",
      rightPhone: "/images/signUpSection/right.webp",
    },
  },
  reviews: {
    item_0: {
      stars: "5",
      description:
        "Vitae sem augue sed aliquet magna. Sit posuere id lobortis varius. Facilisis cursus quam nulla hac. Varius eget non lobortis nibh rhoncus pharetra maecenas.",
      clientName: "Client Name",
      companyName: "Company Name",
    },
    item_1: {
      stars: "4",
      description:
        "Risus integer erat ut lobortis tristique mattis ante aliquet nunc. Quam quis nisi volutpat id. Amet viverra aliquam morbi amet ipsum dictum.",
      clientName: "Client Name",
      companyName: "Company Name",
    },
    item_2: {
      stars: "3",
      description:
        "Vitae sem augue sed aliquet magna. Sit posuere id lobortis varius. Facilisis cursus quam nulla hac. Varius eget non lobortis nibh rhoncus pharetra maecenas.",
      clientName: "Client Name",
      companyName: "Company Name",
    },
    item_3: {
      stars: "2",
      description:
        "Vitae sem augue sed aliquet magna. Sit posuere id lobortis varius. Facilisis cursus quam nulla hac. Varius eget non lobortis nibh rhoncus pharetra maecenas.",
      clientName: "Client Name",
      companyName: "Company Name",
    },
  },
  solutions: {
    retail: {
      title: "Retail",
      shortDesc: "Boost Customer Engagement with QR Codes.",
      url: "/en/solutions/retail",
    },
    hospitality: {
      title: "Hospitality",
      shortDesc: "Elevating Guest Experiences with QR Codes.",
      url: "/en/solutions/hospitality",
    },
    technologySoftwareHardware: {
      title: "Technology Software & Hardware",
      shortDesc: "Streamlining User Access with QR Codes.",
      url: "/en/solutions/technology-software-hardware",
    },
    insurance: {
      title: "Insurance",
      shortDesc: "Simplifying Policy Management with QR Codes.",
      url: "/en/solutions/insurance",
    },
    professionalServices: {
      title: "Professional Services",
      shortDesc: "Share contact details seamlessly.",
      url: "/en/solutions/professional-services",
    },
    consumerPackagedGoods: {
      title: "Consumer Packaged Goods",
      shortDesc: "Share contact details seamlessly.",
      url: "/en/solutions/consumer-packaged-goods",
    },
    mediaEntertainment: {
      title: "Media & Entertainment",
      shortDesc: "Boosting Content Interaction with QR Codes.",
      url: "/en/solutions/media-entertainment",
    },
    developers: {
      title: "Developers",
      shortDesc: "Share contact details seamlessly.",
      url: "/en/solutions/developers",
    },
    marketingAgency: {
      title: "Marketing Agency",
      shortDesc: "Driving Campaign Engagement with QR Codes.",
      url: "/en/solutions/marketing-agency",
    },
    publicFigures: {
      title: "Public figures",
      shortDesc: "Share contact details seamlessly.",
      url: "/en/solutions/public-figures",
    },
    restaurant: {
      title: "Restaurant",
      shortDesc: "Enhancing Dining with QR Code Menus.",
      url: "/en/solutions/restaurant",
    },
    education: {
      title: "Education",
      shortDesc: "Enhancing Learning with QR Code Technology.",
      url: "/en/solutions/education",
    },
    financialServices: {
      title: "Financial Services",
      shortDesc: "Share contact details seamlessly.",
      url: "/en/solutions/financial-services",
    },
    healthcare: {
      title: "Healthcare",
      shortDesc: "Streamlining Patient Care with QR Codes.",
      url: "/en/solutions/healthcare",
    },
  },
  error404: {
    title: "404 - Page Not Found | QRHUB",
    description: "The page you are looking for could not be found.",
    errorNumber: "404",
    errorTitle: "Oops page not found",
    errorDescription:
      "It looks like you got lost in space, or the content you are looking for is no longer available",
    goBackHome: "Go back home",
  },

  // Meno page
  nav: {
    features: "Features",
    howItWorks: "How It Works",
    pricing: "Pricing",
    faq: "FAQ",
    startFreeTrial: "Start Free Trial",
    needHelp: "Need Help?",
  },
  hero: {
    badge: "by QRHUB",
    headline1: "The digital menu",
    headline2: "that actually gets",
    headline3: "you",
    headlineAccent: "orders.",
    sub: "Stop just showing your menu. Start selling with it. Build an interactive digital menu, manage all your branches, and take orders straight to WhatsApp.",
    mockupAlt:
      "Risotto Vero restaurant menu displayed on Meno digital ordering platform",
    cta: "Start Your Free Trial",
    ctaSecondary: "See How It Works",
    trial: "30-day free trial.",
  },
  businessType: {
    titleFirst: "Built for",
    titleSecond: "Ready for",
    titleThird: "menus.",
    titleFourth: "products.",
    sub: "Whether you sell food or physical products, MENO helps you list, share, and receive orders directly through WhatsApp.",
    toggleFood: "I'm Selling Food",
    toggleProducts: "I'm Selling Products",
    food: {
      badge: "Food Menu",
      title1: "Your menu, ready",
      title2: "to take orders.",
      desc: "Create a digital menu for your restaurant, café, cloud kitchen, bakery, or home food business. Share one link or QR code, let customers browse your items, add to cart, and send their order directly to your WhatsApp.",
      tag1: "Restaurants",
      tag2: "Cafés",
      tag3: "Home Bakers",
      tag4: "Cloud Kitchens",
      sub1: "No app needed. ",
      sub2: "No complicated checkout. ",
      sub3: "Just your menu, your link, and your WhatsApp.",
    },
  },
  compare: {
    title1: "Why businesses are switching to",
    titleAccent: "Meno",
    sub: "The old way is broken. Here's the better way.",
    oldWay: "The old way",
    menoWayPrefix: "The ",
    menoWaySuffix: " way",
    ctaReady: "Ready to make the switch?",
    ctaButton: "Get started now",
    old1: "Paying more for every feature.",
    old2: "Clunky PDF menus that customers hate.",
    old3: "Reprinting menus for one price change.",
    old4: "Juggling different menus for each branch.",
    old5: "Losing sales because ordering is a hassle.",
    new1: "One flat fee per location. All features included.",
    new2: "A beautiful, mobile-first experience.",
    new3: "Update prices and items instantly, anytime.",
    new4: "One dashboard to manage all your locations.",
    new5: "Orders sent straight to your WhatsApp.",
  },
  compareV2: {
    badge: "The Difference",
    title1: "The old way, and",
    titleAccent: "the Meno way.",
    oldWay: "The old way",
    withMeno: "With Meno",
    r1: {
      label: "Commission on your orders",
      old: "Yes, every order",
      meno: "0%",
    },
    r2: {
      label: "Take orders, not just display",
      old: "Display only",
      meno: "Straight to WhatsApp",
    },
    r3: {
      label: "Update prices instantly",
      old: "Reprint / re-upload",
      meno: "One click",
    },
    r4: {
      label: "Run many locations from one place",
      old: "Juggled by hand",
      meno: "One dashboard",
    },
    r5: {
      label: "Different price per location",
      old: "Not really",
      meno: "Built in",
    },
    r6: {
      label: "Build each item only once",
      old: "Re-typed each time",
      meno: "Master catalog",
    },
    r7: {
      label: "Your brand, not theirs",
      old: "Their brand wins",
      meno: "Fully white-label",
    },
    r8: {
      label: "Needs a payment gateway",
      old: "Required",
      meno: "Not required",
    },
    r9: {
      label: "Works in minutes",
      old: "Days of setup",
      meno: "Excel import",
    },
  },
  analytics: {
    badge: "Advanced Analytics",
    title: "Understand your customers",
    lead: "See exactly who's ordering, where they're from, and what they want.",
    sub: "Real-time insights to optimize your menu and grow your business.",
    f1: {
      title: "Scan and visit monitoring",
      desc: "Track how often your outlet's QR code is scanned and menu links are visited in real-time.",
    },
    f2: {
      title: "Geographic insights",
      desc: "See which countries and cities your customers are from, helping you understand your reach.",
    },
    f3: {
      title: "Device and platform analytics",
      desc: "Understand what devices, operating systems, and languages your customers use.",
    },
    f4: {
      title: "Traffic source tracking",
      desc: "Identify where your traffic comes from: direct scans, social media, and more.",
    },
    statsQrScans: "2,240",
    statsLinkVisits: "1,220",
    qrScansLabel: "QR Scans",
    linkVisitsLabel: "Link Visits",
    visitorLocations: "Visitor Locations",
    live: "Live",
    topItem: "Top Item",
    topItemName: "Spicy Tacos",
    growth: "55% Growth",
    liveTraffic: "Real-time Insights",
    mobile: "Mobile",
    desktop: "Desktop",
    dashboardAlt:
      "Meno analytics dashboard showing 2,240 QR scans and 1,220 link visits",
  },
  features: {
    title: "All the power. None of the pain.",
    sub: "Everything you need to run your digital menu like a pro.",
  },
  f1: {
    badge: "Quick Setup",
    title1: "Go live in minutes,",
    title2: "not days.",
    desc: "Your time is valuable. Upload your entire catalog with a single Excel file items, categories, and pricing all in one place. Then customize with add-ons, variations, and advanced pricing options whenever you're ready. You'll be selling before your coffee gets cold.",
    tag1: "Excel Import",
    tag2: "Delivery Platform Sync",
    tag3: "Drag & Drop",
  },
  f2: {
    badge: "Outles",
    title1: "Custom price at each outlet.",
    desc1:
      "Create one master catalog for your brand, then assign items to any outlet or menu. Update photos, descriptions, variations, or add-ons once, and MENO syncs them across every location instantly.",
    desc2:
      "Need different prices for each branch? Set custom pricing per outlet without changing the original price.",
    tag1: "Global Items",
    tag2: "Per-Location Menu",
    tag3: "Custom Pricing",
    loc1: "Downtown Branch",
    loc2: "Mall Location",
    loc3: "Airport Outlet",
    loc4: "Beach Cafe",
    items: "items",
    dashboardAlt: "Multi-location dashboard showing 4 restaurant branches",
  },
  f3: {
    badge: "Orders to WhatsApp",
    title1: "Order by WhatsApp.",
    title2: "No POS integration.",
    title3: "No payment gateway required.",
    desc: "Skip the merchant account and the integration. Take cash on delivery, tap a card on your own POS at the door, or send a payment link, you choose per location, the customer chooses at checkout.",
    payLink: "Payment Link",
    payLinkDesc:
      "The restaurant sends a secure payment link after receiving the order.",
    payCash: "Cash on Delivery",
    payCashDesc: "The customer pays in cash when the order arrives.",
    payCard: "Card on Delivery",
    payCardDesc:
      "The customer pays by card using your POS machine at the door.",
    note: "Enable or disable each payment option from your dashboard. Each location can have its own configuration.",
    note2: "Ask your customers how they'd like to pay",
  },
  f4: {
    badge: "Customization",
    title: "Your brand, your vibe.",
    desc: "Set your brand colors and design your intro page with your logo and background. Then take full control of your QR code customize patterns, colors, logo placement, and every detail. Your menu becomes an extension of your brand, not a generic afterthought.",
    qrTitle: "Custom QR Code",
    qrSub: "With your logo & colors",
  },
  f5: {
    badge: "Multi-Language",
    title: "Speak their language.",
    desc: "Add your own accurate translations in up to 14 global languages. You control the quality. Allergy labels are auto-translated from our preset library, so everyone stays safe.",
  },
  products: {
    badge: "Product Catalog",
    title1: "Perfect for your",
    title2: "products, too.",
    desc: "MENO is not only for restaurants. Use it to create a simple product catalog for Instagram sellers, boutiques, artists, home businesses, and pop-up shops. Add your products, share your link, and receive customer orders directly on WhatsApp.",
    tag1: "Instagram Sellers",
    tag2: "Boutiques",
    tag3: "Artists",
    tag4: "Home Businesses",
    sub1: "No full website needed. ",
    sub2: "No complicated checkout. ",
    sub3: "Just your products and your WhatsApp.",
  },
  f6: {
    badge: "No Commission",
    title1: "We take 0% of your orders. Forever.",
    desc: "Delivery platforms take a slice of every order you make. Meno doesn't take a cent. You pay one flat, predictable fee per location monthly or yearly and keep 100% of every sale. Sell ten orders or ten thousand: your Meno bill doesn't move.",
    tag1: "No per-order commission",
    tag2: "No per-scan fee",
    tag3: "No feature paywall",
    tag4: "Every feature, every plan",
    commission: "commission",
    commissionAriaLabel: "Commission countdown from 30% to 0%",
  },
  brandLook: {
    badge: "Your Brand, Your Look",
    title1: "It looks like",
    titleAccent: "you",
    desc: "Upload your logo, set your brand color, choose a cover image or color, your menu carries your identity end to end. Then open it to the world. Translate your menu into 14 languages, and choose which languages each location offers.",
    brandColorLabel: "BRAND COLOR",
    brandColorHint: "TAP TO PREVIEW",
    menuLanguageLabel: "MENU LANGUAGE",
  },
  richItems: {
    badge: "Rich items that sell",
    title1: "Items worth tapping",
    titleAccent: "Add",
    title2: "on.",
    desc: "Every dish is a proper product page, not a line on a list.",
    f1: {
      title: "Photos & video",
      desc: "First image becomes the cover.",
    },
    f2: {
      title: "Variations",
      desc: "Sizes & options, each with its own price.",
    },
    f3: {
      title: "Add-ons & required choices",
      desc: '"Pick a sauce" or "add extras," each priced.',
    },
    f4: {
      title: "Sale pricing",
      desc: "Strike the old price; discount shows automatically.",
    },
    f5: {
      title: "Recommended pairs",
      desc: "Suggest a side or drink to lift every order.",
    },
    f6: {
      title: "Calories, allergens & SKU",
      desc: "Specs built in, plus per-item order counts.",
    },
    mockup: {
      photoCount: "1/3 photos",
      productName: "BBQ Platter",
      description: "Smoky half-rack, slow-cooked, brushed with house sauce.",
      calories: "820 kcal",
      allergens: "Gluten, Dairy",
      variation: "Variation",
      regular: "Regular · $50",
      large: "Large · $72",
      chooseSauce: "Choose a sauce ·",
      required: "required",
      greenSauce: "Green Sauce",
      smokyBbq: "Smoky BBQ",
      add: "Add · $50.00",
    },
  },
  teamRoles: {
    badge: "Team & Roles",
    title1: "Run every outlet with",
    titleAccent: "the right hands.",
    desc: "Invite your team to a workspace and give each person exactly the access they need, so managers run their branch and staff fulfil orders, without touching anything else.",
    cardAria: "Team members management preview",
    cardTitle: "Team Members",
    cardWorkspace: "Workspace: ACME Restaurant",
    inviteButton: "+ Invite User",
    colUser: "User",
    colRole: "Role",
    emailPlaceholder: "Enter email address",
    roles: {
      admin: {
        title: "Admin",
        desc: "Full access to the whole workspace: catalog, outlets, branding and team.",
      },
      manager: {
        title: "Outlet Manager",
        desc: "Manage menus, prices, opening hours and orders for the outlets they're assigned to.",
      },
      operator: {
        title: "Outlet Operator",
        desc: "Receive and fulfil incoming WhatsApp orders at their outlet, nothing more.",
      },
    },
    members: {
      owner: {
        initials: "DS",
        name: "Dexter Snow",
        handle: "@dextersnow",
        role: "Owner",
      },
      manager: {
        initials: "JD",
        name: "John Doe",
        handle: "@johndoe · Miami Outlet",
        role: "Outlet Manager",
      },
      operator: {
        initials: "AK",
        name: "Aamir Khan",
        handle: "@aamirkhan · Main Branch — NY",
        role: "Outlet Operator",
      },
    },
  },
  how: {
    title: "Live in minutes, not days.",
    sub: "Three steps. That's all it takes.",
    step: "STEP",
    s1: {
      title: "Set up your workspace",
      desc: "Create your Meno workspace in seconds. Add your business details and invite your team.",
    },
    s2: {
      title: "Build your menu",
      desc: "Add items, create categories, upload images, and organize everything exactly how you want it.",
    },
    s3: {
      title: "Generate & serve",
      desc: "Download your custom QR codes, share your link, and watch the orders come in. Done.",
    },
  },
  menoSteps: {
    title1: "From zero to taking orders,",
    title2: "Today.",
    sub: "Everything you need to run your digital menu like a pro.",
    steps: {
      s1: {
        headline: "Build your items once",
        subheading: "Get your menu live in minutes.",
        bullets: [
          "Add item names, photos or videos, prices, variations, and add-ons.",
          "Import everything from a single Excel file or enter items manually.",
          "Each item only needs to be created once.",
        ],
        imageAlt: "Build your items once",
      },
      s2: {
        headline: "Create your outlets & menus.",
        subheading: "Control your menu experience from one dashboard.",
        bullets: [
          "Create an outlet for each branch or store.",
          "Choose which menu items appear for each outlet.",
          "Set different prices per outlet, with a unique page and QR code for every outlet.",
        ],
        imageAlt: "Customize and manage",
      },
      s3: {
        headline: "Share it and take orders.",
        subheading: "One menu link. One order link. Clear insights.",
        bullets: [
          "Share your menu with one link or branded QR code anywhere.",
          "Customers browse, add to cart, and send their order through one clear order link.",
          "Track performance with analytics, reports, and customer reviews on your items.",
        ],
        imageAlt: "Share and get orders",
      },
    },
  },
  pricingV2: {
    badge: "Pricing",
    title1: "One plan. Everything in.",
    titleAccent: "Zero commission.",
    sub: "No commission, no per-scan charges, no feature paywalls — every feature below is included. Pay one flat fee per location and add outlets only as you grow.",
    pro: "PRO",
    priceYearly: "$24",
    priceMonthly: "$29",
    perMonth: "/month",
    priceYearlyNote: "per month, billed yearly ($290/yr)",
    priceMonthlyNote: "billed monthly",
    saveBadge: "2 months free",
    basePlan: "Base plan includes 1 outlet",
    outletsTitle: "ADD OUTLETS AS YOU GROW",
    outlet1_10: "1-10 outlets",
    outlet11plus: "11+ outlets",
    outlet1_10AmountYearly: "$15",
    outlet1_10AmountMonthly: "$18",
    outlet11plusAmountYearly: "$12",
    outlet11plusAmountMonthly: "$14",
    outletPriceUnit: "/outlet · mo",
    commissionNote:
      "0% commission on every order, only pay for the outlets you actually run.",
    trialTitle: "30-day free trial",
    trialDesc: "Try every feature.",
    cta: "Start Your 30-Day Free Trial",
    featuresTitle: "Everything included",
    featuresBadge: "EVERY PLAN",
  },
  pricing: {
    unbeatable_value: "Unbeatable value per location",
    monthly: "Monthly",
    yearly: "Yearly",
    save_badge: "Save 40%",
    title: "Simple, transparent pricing.",
    sub: "No hidden fees. No feature restrictions. No per scan charges. You get every feature, right from day one.",
    badge: "All Features Included",
    flat: "Flat fee per location. Everything unlocked.",
    price_label: "Base plan includes (1 outlet)",
    additional_outlets: "Additional outlets",
    outlet_1_10: "(1-10)",
    outlet_11_plus: "(11+)",
    f1: "Unlimited items & categories",
    f2: "14 language translations",
    f3: "WhatsApp ordering integration",
    f4: "Custom pricing & variations",
    f5: "Custom branded QR codes",
    f6: "Variations, add-ons and product suggestions",
    f7: "Team member management",
    f8: "Excel import",
    f9: "Orders management",
    f10: "Full analytics per location: country, device, source, and much more",
    cta: "Start your 30-day free trial",
    noCc: "No credit card required.",
  },
  qrhub: {
    title: "Already using QRHUB?",
    desc: "Switch between QRHUB and Meno workspaces from the same account. Create a Meno workspace instantly and start selling.",
    cta: "Go to dashboard",
  },
  needHelp: {
    badge: "Support",
    title: "How Can We Help?",
    desc: "Whether you're getting started with Meno, need technical support, or have a partnership inquiry, our team is ready to help.",
    cta: "Get in Touch",
  },
  faq: {
    badge: "FAQ",
    title1: "Questions,",
    titleAccent: "answered.",
    sub: "Everything a non-technical owner asks before going live.",
    title: "Got questions?",
    q1: "Is Meno just for restaurants?",
    a1: "Not at all. While Meno is perfect for restaurants, it's designed for any business that needs a simple way to display products and take orders. Instagram sellers, home bakers, artists, pop-up shops, if you have something to sell, Meno works for you.",
    q2: "How does the pricing work?",
    a2: "Simple. You pay a flat rate for every location you operate. That fee unlocks 100% of Meno's features. No premium tiers, no up-sells, no surprises.",
    q3: "Can I have different prices for the same item at different locations?",
    a3: "Yes. Meno lets you set a default price for an item and then override it with custom prices for specific locations. No need to duplicate items.",
    q4: "How does the WhatsApp ordering work?",
    a4: "Customers browse your menu, add items to their cart, and choose a payment method (Pay by Link, Cash, or Card). When they submit, their complete order is sent directly to your WhatsApp as a link. You receive a clean, structured order with all the details.",
    q5: "Do I need a website or POS system?",
    a5: "Not at all. Meno can be your simple, powerful online ordering system. You take the order from WhatsApp and process it manually. No complicated integrations needed.",
    q6: "How fast can I get started?",
    a6: "If you have your product list in an Excel sheet, you can be live before your coffee gets cold. Seriously. Upload your file, customize your theme, generate your QR code, and go live.",
  },
  cta: {
    title1: "Stop showing your menu. ",
    title2: "Start selling with it.",
    sub: "Build it once, brand it as yours, and take orders on WhatsApp with zero commission.",
    button: "Start Your 30-Day Free Trial",
    buttonSecondary: "See How It Works",
    trial: "30-day free trial · 0% commission",
  },
  footer: {
    byQrhub: "by QRHUB",
    rights: "QRHUB. All rights reserved.",
  },
  seo: {
    menoDigitalMenu: {
      title: "Meno - Digital Menu & WhatsApp Ordering",
      description:
        "Meno is a digital menu platform that helps restaurants, cafes, and product businesses take orders directly through WhatsApp. No POS integration needed. Try free for 30 days.",
      keywords:
        "digital menu, WhatsApp ordering, restaurant menu, online ordering, multi-location menu management",
      ogDescription:
        "Turn your menu into a sales machine. Manage all locations from one dashboard and take orders straight to WhatsApp.",
    },
  },
};

export default en;
